import api from './api';

export const listSections = (workshopId) =>
  api.get(`/workshops/${workshopId}/sections`).then(r => r.data);

export const getSectionDetail = (sectionId) =>
  api.get(`/sections/${sectionId}`).then(r => r.data);

export const createSection = (workshopId, data) =>
  api.post(`/workshops/${workshopId}/sections`, data).then(r => r.data);

export const updateSection = (sectionId, data) =>
  api.put(`/sections/${sectionId}`, data).then(r => r.data);

export const deleteSection = (sectionId) =>
  api.delete(`/sections/${sectionId}`).then(r => r.data);
